module.exports = __webpack_public_path__ + "img/jp.a1e1ea51.svg";